import { useQuery } from '@sequencehq/api'
import {
  Dashboardv99990101Api,
  dashboardv99990101Client
} from '@sequencehq/api/dashboard/v99990101'
import {
  NETSUITE_ITEM_ACCOUNT_DEFAULT_LABEL,
  NETSUITE_ITEM_STALE_TIME,
  findNetsuiteItemId,
  netsuiteItemFallbackLabel,
  useIntegrationActive
} from 'Integrations/index'

/**
 * What the grant detail panel shows for the grant's NetSuite item, or `null`
 * to leave the row out. A grant with no item uses the account default, which
 * only means something while NetSuite is connected.
 */
export const useNetsuiteItemLabel = (
  grant: Dashboardv99990101Api.CreditGrants.CreditGrantV2
): string | null => {
  const isNetsuiteActive = useIntegrationActive('NetSuite')
  const itemId = findNetsuiteItemId(grant.integrationIds)
  const itemQuery = useQuery(
    dashboardv99990101Client.getNetsuiteItem,
    { id: itemId ?? '' },
    {
      // A disconnected NetSuite can only answer with an error.
      enabled: Boolean(itemId) && isNetsuiteActive,
      staleTime: NETSUITE_ITEM_STALE_TIME,
      // A missing or invalid item fails the same way every time, and the id
      // is a fine stand-in, so don't hold the row on retries.
      retry: false
    }
  )

  if (!itemId) {
    return isNetsuiteActive ? NETSUITE_ITEM_ACCOUNT_DEFAULT_LABEL : null
  }
  if (itemQuery.data) {
    return `${itemQuery.data.name} (${itemId})`
  }
  if (!isNetsuiteActive || itemQuery.isError) {
    return netsuiteItemFallbackLabel(itemId)
  }
  return '—'
}
